import { useState, useEffect, useContext } from "react";
import { Button, Col, Dropdown, Image, Row } from "antd";
import { BellOutlined } from "@ant-design/icons";
import Logo from "../../assets/images/duepay-logo.svg";

import notfound from "../../assets/images/not_found.png";
import { useNavigate } from "react-router-dom";
import { Severty, ShowToast } from "../../helper/toast";
import { AuthContext } from "../../context/AuthContext";
import { useAppContext } from "../../context/AppContext";
import lang from "../../helper/lang";
import NotificationImage from "../../assets/images/bell_iconnn.png";
import useRequest from "../../hooks/useRequest";
import profilavatar from "../../assets/images/profilImage.jpg";

const NOTIFICATION_PAGE_SIZE = 10;
const toggler = [
  <svg
    width="20"
    height="20"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 448 512"
    key={0}
  >
    <path d="M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"></path>
  </svg>,
];

function Header({ onPress, setToggle }) {
  const { request } = useRequest();
  const [notificationVisible, setNotificationVisible] = useState(false);
  const { setUserProfile } = useContext(AuthContext);
  const navigate = useNavigate();
  const { notification = [], notificationCount = 0, setNotification, setNotificationCount } = useAppContext();
  const [notificationPage, setNotificationPage] = useState(1);
  const [hasMoreNotifications, setHasMoreNotifications] = useState(true);
  const [isNotificationLoading, setIsNotificationLoading] = useState(false);
  const fetchNotifications = (page = 1, shouldAppend = false) => {
    if (isNotificationLoading) return;
    setIsNotificationLoading(true);

    request({
      url: `api/admin/notifications?page=${page}&limit=${NOTIFICATION_PAGE_SIZE}`,
      method: "GET",
      onSuccess: (res) => {
        const pageData = res?.data?.docs || res?.data || [];
        const totalItems = res?.data?.totalDocs ?? res?.pagination?.total;

        setNotification((prev) => {
          if (!shouldAppend) return pageData;
          const merged = [...prev, ...pageData];
          const uniqueMap = new Map();
          merged.forEach((item, idx) => {
            uniqueMap.set(item?.id ?? `idx-${idx}`, item);
          });
          return Array.from(uniqueMap.values());
        });

        // const unreadCount = pageData.filter((item) => item.is_read === false).length;
        res?.unread_count && res?.unread_count > 0 && setNotificationCount(res?.unread_count);

        if (typeof totalItems === "number") {
          setHasMoreNotifications(page * NOTIFICATION_PAGE_SIZE < totalItems);
        } else {
          setHasMoreNotifications(pageData.length === NOTIFICATION_PAGE_SIZE);
        }
        setNotificationPage(page);
        setIsNotificationLoading(false);
      },
      onError: (error) => {
        console.log(error);
        setIsNotificationLoading(false);
      },
    });
  };

  const markAllNotificationsAsRead = () => {
    request({
      url: "api/admin/notifications",
      method: "PUT",
      onSuccess: (data) => {
        console.log("markAllNotificationsAsRead", data);
        setNotificationCount(0);
      },
      onError: (error) => {
        console.log("markAllNotificationsAsRead error", error);
      },
    });
  };

  useEffect(() => {
    request({
      url: "/auth/get-profile",
      method: "GET",
      onSuccess: (data) => {
        if (data && data.data) {
          setUserProfile({
            id: data.data.id,
            first_name: data.data.first_name,
            middle_name: data.data.middle_name,
            last_name: data.data.last_name,
            username: data.data.username,
            email: data.data.email,
            email_verified: data.data.email_verified,
            country_code: data.data.country_code,
            mobile: data.data.mobile,
            user_type: data.data.user_type,
            status: data.data.status,
            join_date: data.data.join_date,
            profile_img: data.data.profile_img,
          });
          fetchNotifications();
        } else {
          console.error("Invalid response data:", data);
          ShowToast("Failed to load profile data", Severty.ERROR);
        }
      },
      onError: (error) => {
        console.log(error);
        ShowToast(error, Severty.ERROR);
      },
    });
  }, []);

  const handleNotificationScroll = (event) => {
    const target = event?.currentTarget;
    if (!target || isNotificationLoading || !hasMoreNotifications) return;

    const reachedBottom =
      target.scrollHeight - target.scrollTop <= target.clientHeight + 20;

    if (reachedBottom) {
      fetchNotifications(notificationPage + 1, true);
    }
  };

  const notificationContent = (
    <div className="notification_top">
      <div className="notification-head">
        <h5>{lang("Notifications")}</h5>
      </div>
      <div className="notification-inner" onScroll={handleNotificationScroll}>
        {notification?.length ? (
          notification.map((item, index) => (
            <div
              key={item.id || index}
              className="single-notification"
              onClick={() => {
                setNotificationVisible(false);
                if (item.ticket) {
                  navigate(`/support?ticket=${item.ticket}`);
                  return;
                }
                navigate("/support");
              }}
            >
              <div className="notification-pill">
                <BellOutlined />
              </div>
              <div className="notification-cont">
                <span className="notification-title">Notification</span>
                <p className="notification-desc">{item.message || "You have received a notification"}</p>
                <small className="notification-meta">
                  {item.ticket ? `Ticket: #${item.ticket}` : ""}
                </small>
                <small className="notification-time">
                  {item.time ? new Date(item.time).toLocaleString() : ""}
                </small>
              </div>
            </div>
          ))
        ) : (
          <div className="notification-empty">{lang("No Notification")}</div>
        )}
        {isNotificationLoading && (
          <div className="notification-empty">Loading...</div>
        )}
      </div>
      {/* <div className="viewAll_notification">
        <Button
          onClick={() => navigate("/notification-manager")}
          className="btnStyle btn_primary"
        >
          {lang("View All")}
        </Button>
      </div> */}
    </div>
  );

  const { userProfile } = useContext(AuthContext);
  const profilePic =
    userProfile?.profile_img || userProfile?.profilePic || profilavatar || notfound;

  const userName =
    (userProfile?.first_name ?? "") + " " + (userProfile?.middle_name ?? "") + " " + (userProfile?.last_name ?? "") || "User";
  return (
    <>
      <Row className="align-items-center">
        <Col span={24} xs={18} md={18}>
          <div className="toggale-headr">
            <div className="moblile-toggle d-lg-none">
              <Button
                type="link"
                className="sidebar-toggler"
                onClick={() => onPress()}
              >
                {toggler}
              </Button>
            </div>
            <div className="">
              <Button
                type="link"
                className="sidebar-toggler ps-0 d-none d-lg-block"
                onClick={() => setToggle()}
              >
                {toggler}
              </Button>
            </div>
            <div className="tabLogo ">
              <img src={Logo} alt="logo" width={85} className="d-lg-none" />
              <h4 className="d-none d-lg-block">{lang("DuePay - Admin Panel")}</h4>
            </div>
          </div>
        </Col>
        <Col span={24} xs={6} md={6} className="header-control">
          <div className="d-flex align-items-center justify-content-end gap-3">
            {/* Notification Dropdown */}
            <div className="notificationDropdownMain">
              <Dropdown
                overlay={notificationContent}
                placement="bottomRight"
                trigger={["click"]}
                open={notificationVisible}
                onOpenChange={(open) => {
                  setNotificationVisible(open);
                  if (!open) {
                    markAllNotificationsAsRead();
                  }
                  // if (open) {
                  // fetchNotifications(1, false);
                  // }
                }}
              >
                <span className="notification-btn">
                  <div className="notification-icon-wrapper">
                    <img
                      src={NotificationImage}
                      alt="notification"
                      className="notification-icon"
                    />
                    {notificationCount > 0 && (
                      <span className="notification-badge">
                        {notificationCount > 99 ? "99+" : notificationCount}
                      </span>
                    )}
                  </div>
                </span>
              </Dropdown>
            </div>

            {/* Profile Dropdown */}
            <div className="profileDropdownMain">
              <Button
                className="ant-btn ant-btn-default ant-dropdown-trigger ant-dropdown-open"
                onClick={() => navigate("/profile")}
              >
                <div className=" d-flex align-items-center gap-2">

                  <div className="d-none d-xl-block">
                    <div className="userName">Welcome {userName}</div>
                  </div>
                  <div className="userImg" style={{ cursor: "pointer" }}>
                    <Image src={profilePic} preview={false} />
                  </div>
                </div>
              </Button>
            </div>
          </div>
        </Col>
      </Row>
    </>
  );
}

export default Header;
